import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ErrorBoundary from '../components/ui/ErrorBoundary';

const ApplicationSubmitted = () => {
  const navigate = useNavigate();
  const { confirmationNumber } = useAuth();
  
  // Fallback to localStorage if confirmation number is not in context
  const displayConfirmationNumber = confirmationNumber || localStorage.getItem('confirmation_number');

  return (
    <ErrorBoundary>
      <div className="form-container">
        <div className="form-content">
          <div className="success-message">
            <h2>Application Submitted Successfully!</h2>
            <p>
              Thank you for submitting your vendor application to VReels Shop. 
              Your application has been received.
            </p>
            {displayConfirmationNumber && (
              <div className="confirmation-number">
                <h3>Confirmation Number</h3>
                <p className="confirmation-code">{displayConfirmationNumber}</p>
                <p className="confirmation-note">
                  Please save this confirmation number for future reference.
                </p>
              </div>
            )}
           </div>
          </div>
        </div>
    </ErrorBoundary>
  );
};

export default ApplicationSubmitted;
